/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-15 15:09:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/MiniShare/index.tsx
 */

import React from 'react';

//import css from './css.less';
import { useDispatch } from 'react-redux';
import _MiniProgramShare from 'src/constrains/SalesChannelPreviewPageComponents/MiniProgramShare';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getGeneralMiniProgramShare,
  onCollapseOpen,
  onErrorChange,
  onMiniProgramShareChange,
} from '../slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

const MiniProgramShare = (props) => {
  const { data, disabled, hideEdit } = props;

  const _d = useDispatch();

  const { shareCoverImage, shareTitle } = data || {};

  const handleOnImageChange = (image) => {
    _d(onMiniProgramShareChange({ shareCoverImage: image }));
  };

  const handleOnTitleChange = (shareTitle) => {
    _d(onMiniProgramShareChange({ shareTitle }));
  };

  return (
    <React.Fragment>
      <_MiniProgramShare
        image={shareCoverImage}
        text={shareTitle}
        disabled={disabled}
        onImageChange={handleOnImageChange}
        onTextChange={handleOnTitleChange}
        hideEdit={hideEdit}
      />
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(MiniProgramShare, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.miniProgramShare,
  getContent: getGeneralMiniProgramShare,
  title: getI18nFromGeneral('general.hOCTitle.miniProgramShare'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
